import React, { useEffect } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { Select } from "uxp/components";
import { IPreviewProps } from "@types";
import './styles.scss';

export const PieChartPreview: React.FunctionComponent<IPreviewProps> = (props) => {
    const [valueField, setValueField] = React.useState('');
    const [labelField, setLabelField] = React.useState('');
    const type = 'pie';
    const chartSize = 80;
    const colors = [
        '#5652C2',
        '#BC59C3',
        '#BB597B',
        '#72C1C7',
        '#ABE087',
        '#C76663',
    ];
    function getTooltipText(item: any) {
        return `${item?.[labelField || 'name']} : ${(item?.[valueField || 'value'])}`

    }
    let schema = props.schema || [];
    useEffect(() => {
        if (props.schema && !valueField) {
            let item = schema.find((x) => x.type == 'number');
            if (item) {
                setValueField(item.name);
            }
        }
        if (schema && !labelField) {

            let item = schema.find((x) => x.type == 'string');
            console.log('IMTEIZE', item, schema);
            if (item) {
                setLabelField(item.name);
            }

        }
    }, [props.schema]);
    let numericFields = schema.filter((x) => x.type == 'number');
    if (numericFields.length == 0) {
        numericFields = schema;
    }
    return <div className='qe-preview-pie-chart'>
        <div className='qe-preview-chart-props'>
            <label>Value</label>
            <Select renderOption={(option, key) => <div className={'qe-chart-select-option ' + (option.type == 'number' ? '' : 'disabled')}>{option.name}</div>} className="lucy-query-engine-input" onChange={setValueField} options={schema} labelField="name"
                valueField="name" selected={valueField} />
            <label>Label</label>
            <Select
                renderOption={(option, key) => <div className={'qe-chart-select-option ' + (option.type == 'string' ? '' : 'disabled')}>{option.name}</div>}
                className="lucy-query-engine-input" onChange={setLabelField} options={schema} labelField="name"
                valueField="name" selected={labelField} />
        </div>
        <div className='qe-preview' style={{ maxWidth: '800px' }}>
            {
                (valueField && labelField) ?
                    <ResponsiveContainer  >
                        <PieChart

                        >
                            <Pie
                                dataKey={valueField || 'value'}

                                labelLine={false}
                                data={props.data?.map((x: any) => {
                                    var y = { ...x };
                                    y[valueField] = Number(y[valueField]);
                                    return y;
                                })}
                                fill="#FFFFFF00"
                                paddingAngle={1}
                                innerRadius={type == 'pie' ? 0 : `${(chartSize || 80) * 0.67}%`}
                                outerRadius={`${chartSize || 80}%`}
                                cx="50%" cy="50%"
                                isAnimationActive={false}
                                label={({
                                    cx,
                                    cy,
                                    midAngle,
                                    innerRadius,
                                    outerRadius,
                                    value,
                                    name,
                                    index,
                                }: any) => {
                                    const RADIAN = Math.PI / 180;
                                    const radius = 20 + Number(innerRadius) + (Number(outerRadius) - Number(innerRadius));
                                    const x = Number(cx) + radius * Math.cos(-midAngle * RADIAN);
                                    const y = Number(cy) + radius * Math.sin(-midAngle * RADIAN);
                                    let color = colors[index % colors.length];

                                    return (
                                        <text
                                            x={x}
                                            y={y}
                                            fill={color}
                                            textAnchor={x > Number(cx) ? "start" : "end"}
                                            dominantBaseline="central"
                                        >
                                            {props.data[index]?.[labelField] || '(Unknown)'}
                                        </text>
                                    );
                                }}
                            >
                                {props.data.map((entry: any, index: number) => {
                                    let _color = colors[index % colors.length]

                                    return (
                                        <Cell stroke={'0'}

                                            fill={_color}
                                        />
                                    )
                                })}
                            </Pie>
                            <Tooltip content={(props) => {
                                return <div className='wd-chart-tooltip'>
                                    <div className="label">{getTooltipText(props?.payload?.[0]?.payload)}</div>
                                </div>
                            }} />
                            {<Legend formatter={(v, e, i) => props.data?.[i]?.[labelField || 'name'] || 'Unknown'} layout="vertical" verticalAlign="middle" align="right" />}
                        </PieChart>
                    </ResponsiveContainer>
                    : <div className='pie-chart-info'>Select a field to plot</div>
            }

        </div>
    </div>
}
